<template>
    <div class="basket pa-2 mb-2 subPrimary">
      <div class="group">
        <h4 class="mt-2">
          <v-badge right overlap color="primary" class="">
            <span slot="badge" class="badgeSize" >{{ partTypes.length }}</span>
            <v-icon>shopping_basket</v-icon>
          </v-badge>
          <!-- <span v-if="partTypes.length > 100" class=" primary--text ml-2 mr-2 mb-2 font-weight-bold numberBasket" >{{ partTypes.length }}</span> -->
          <span>{{ title }}</span>
        </h4>
        <v-btn @click="showContent()" icon>
          <v-icon v-show="this.show === false">expand_more</v-icon>
          <v-icon v-show="this.show === true">expand_less</v-icon>
        </v-btn>
      </div>
      <v-divider v-show="this.show"></v-divider>
      <ul v-show="this.show">
        <li class="pa-1" v-for="(part) in partTypes" :key="`${part.id}`" @click="toggleSelected(part)">
          <v-icon color="primary">check_box</v-icon>
          {{ part.name }}
        </li>
      </ul>
    </div>
</template>
<script>
  
  export default {
    name: "CatalogBasket",
    data(){
      return {
        show: false
      }
    },
    props: {
      partTypes: {
        type: Array,
        required: true
      },
      title: {
        type: String
      },
      model: {
        type: String,
        required: true
      }
    },
    methods: {
      toggleSelected(part) {
        this.$emit("Update", { model: this.model, part });
      },
      showContent() {
        if (this.show == true ) 
          this.show = false;
        else 
           this.show = true
      },
    }
  };
</script>
<style lang="stylus">
  .numberBasket{ 
    font-size: 16px
  }

</style>